import styled, { css } from 'styled-components';

import { Picture } from 'components/picture';

export const PriceAndCaloriesListWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  ${Styles.desktop} {
    display: block;
  }
`;

export const StyledTileDescription = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 2rem;
  overflow: ellipsis;

  ${Styles.mobile} {
    height: 3.75rem;
    padding: 0.5rem;
    text-align: center;
  }

  h2 {
    color: ${Styles.color.black};
    font-family: ${Styles.fontFamily.base};
    line-height: 1.11;
    font-size: 1.125rem;
    margin: 0;
    text-transform: ${Styles.textTransform.headlines};
  }

  p {
    color: ${Styles.color.grey.two};
    font-family: ${Styles.fontFamily.body};
    margin-block-start: 0.25rem;
  }
`;

export const tileHeaderStyles = css`
  color: ${Styles.color.black};
  font-family: ${Styles.fontFamily.base};
  line-height: 1.11;
  font-size: 1.125rem;
  margin: 0;
  text-transform: ${Styles.textTransform.headlines};

  ${Styles.desktop} {
    font-size: 1.375rem;
  }
`;

export const TileInner = styled.div``;

export const TileImage = styled(Picture)<{ $isOnMainMenu?: boolean }>`
  overflow: hidden;
  position: relative;
  border-start-start-radius: ${Styles.borderRadius};
  border-start-end-radius: ${Styles.borderRadius};
  border-end-end-radius: 0;
  border-end-start-radius: 0;
  height: 6.25rem;

  ${Styles.desktop} {
    height: 15rem;
  }
`;

export const ListTileImage = styled(Picture)<{ $isOnMainMenu?: boolean }>`
  overflow: hidden;
  position: relative;
  border-radius: ${Styles.borderRadius};
  height: 4.5rem;
  width: 6.5rem;

  ${Styles.desktop} {
    height: 15rem;
    width: unset;
    border-start-start-radius: ${Styles.borderRadius};
    border-start-end-radius: ${Styles.borderRadius};
    border-end-end-radius: 0;
    border-end-start-radius: 0;
  }
`;

export const ItemPrice = styled.span`
  font-weight: ${Styles.fontWeight.heavy};
  color: ${Styles.color.pricing};
`;
